import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from "react-apollo";
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { WebSocketLink } from 'apollo-link-ws';
import { split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import store from './store';

import { PrivateRoute } from "./auth/PrivateRoute";
import BranchContainer from "./containers/Branch";
import BranchFormContainer from "./containers/BranchForm";
import ClientContainer from "./containers/Client";
import ClientFormContainer from "./containers/ClientForm";
import LoginContainer from "./containers/Login";
import VoucherContainer from "./containers/Voucher";
import HomeContainer from "./containers/Home";
import RoomLiveContainer from "./containers/RoomLive";
import RoomsContainer from "./containers/Rooms";
import RoomsFormContainer from "./containers/RoomsForm";
import VouchersContainer from "./containers/Vouchers";
import VouchersFormContainer from "./containers/VouchersForm";
import routes from "./const/routes";

import {
  FaHome,
  FaDesktop,
  FaUsers
} from "react-icons/fa";
import { AiOutlineApartment, AiOutlineQrcode } from "react-icons/ai";

const auth = {
  jedi: ["JEDI"],
  admin: ["JEDI", "Admin"],
  user: ["JEDI", "Admin", "User"]
};

const httpLink = new HttpLink({
  //uri: 'http://localhost:3001/graphql',
  //uri: 'https://osselvelorioonline-back.herokuapp.com/graphql'
  //uri: 'https://osselvelorioonline-api-production.up.railway.app/graphql'
  uri: 'https://cors-sorocaps-beed4061d892.herokuapp.com/52.67.121.155:3001/graphql'
});

const wsLink = new WebSocketLink({
  //uri: `ws://localhost:3001/graphql`,
  //uri: 'wss://osselvelorioonline-back.herokuapp.com/graphql',
  uri: 'wss://52.67.121.155:3001/graphql',
  options: { reconnect: true }
});

const link = split(
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === 'OperationDefinition' && operation === 'subscription';
  },
  wsLink,
  httpLink
)

const cache = new InMemoryCache();
const client = new ApolloClient({ link, cache });

function App() {
  return (
    <Provider store={store}>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <Switch> 
              <Route exact path="/" component={VoucherContainer}/>         
              <Route exact path={routes.ROOM_LIVE} component={RoomLiveContainer}/>         
              <Route exact path={routes.LOGIN} component={LoginContainer}/>
              <PrivateRoute exact path={routes.BRANCHS} component={BranchContainer} pageTitle={"Filiais"} breadcrumb="Filiais" icon={AiOutlineApartment} auth={auth.all}/>
              <PrivateRoute exact path={routes.BRANCHS_FORM} pathB={routes.BRANCHS} component={BranchFormContainer} pageTitle={"Cadastro de Filiais"} breadcrumb="Filiais" breadcrumbSub="Novo" icon={AiOutlineApartment} auth={auth.all}/>
              <PrivateRoute exact path={routes.CLIENTS} component={ClientContainer} pageTitle={"Clientes"} breadcrumb="Clientes" icon={FaUsers} auth={auth.all}/>
              <PrivateRoute exact path={routes.CLIENTS_FORM} pathB={routes.CLIENTS} component={ClientFormContainer} pageTitle={"Cadastro de Clientes"} breadcrumb="Clientes" breadcrumbSub="Novo" icon={FaUsers} auth={auth.all}/>
              <PrivateRoute exact path={routes.HOME} component={HomeContainer} pageTitle={"Dashboard"} breadcrumb="Painel de Controle" auth={auth.user} icon={FaHome}/>
              <PrivateRoute exact path={routes.VOUCHERS} component={VouchersContainer} pageTitle={"Vouchers"} breadcrumb="Vouchers" auth={auth.user} icon={AiOutlineQrcode}/>
              <PrivateRoute exact path={routes.VOUCHERS_FORM} pathB={routes.VOUCHERS} component={VouchersFormContainer} pageTitle={"Cadastro de Vouchers"} breadcrumb="Vouchers" breadcrumbSub="Novo" icon={AiOutlineQrcode} auth={auth.all}/>
              <PrivateRoute exact path={routes.ROOMS} component={RoomsContainer} pageTitle={"Salas"} breadcrumb="Salas" auth={auth.user} icon={FaDesktop}/>
              <PrivateRoute exact path={routes.ROOMS_FORM} pathB={routes.ROOMS} component={RoomsFormContainer} pageTitle={"Cadastro de Salas"} breadcrumb="Salas" breadcrumbSub="Novo" icon={FaDesktop} auth={auth.all}/>
              <Redirect to={routes.HOME}/>
            </Switch>
          </BrowserRouter>
        </ApolloProvider>
      </Provider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js